import React from 'react';

export default function StatCard({ label, value, hint, icon = null, trend = null, className = '' }) {
  return (
    <div className={`bg-background-elevated rounded-xl border border-border/60 p-5 shadow-sm hover:shadow-md hover:border-border transition-all duration-200 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{label}</div>
          <div className="mt-2 text-3xl font-bold text-foreground tabular-nums tracking-tight">{value}</div>
          {hint && <div className="mt-2 text-xs text-muted-foreground/80">{hint}</div>}
        </div>
        {icon && <div className="text-accent/70">{icon}</div>}
      </div>
      {trend && (
        <div className={`mt-3 text-xs font-medium ${trend.positive ? 'text-success' : 'text-danger'}`}>
          {trend.value}
        </div>
      )}
    </div>
  );
}
